module.exports = __webpack_public_path__ + "static/appleStore-5438deba33b151d548cf8c93431a4080.png";